import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';

import { LoanApplicationTasksService } from '../loan-application-tasks/loan-application-tasks.service';
import { LoanAppTask } from '../../models/index';

@Injectable()
export class TodosResolve implements Resolve<LoanAppTask[]> {
  constructor(private service: LoanApplicationTasksService) {}

  resolve(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<LoanAppTask[]> {
    return this.service.getTasks(true);
  }
}
//      , err => {
//        console.error('getTasks error:', err);
//
//        return [{
//          'guid': 'string',
//          'loanApplicationGuid': 'string',
//          'userGuid': 'string',
//          'type': 'UploadDocument',
//          'status': 'NotStarted',
//          'title': 'Upload Income Documents',
//          'requestMessage': 'Please upload most recent paystubs and W2.',
//          'requestedUploadedDocumentTypes': [
//            'PayStubs',
//            'W2'
//          ],
//          'isRequired': true,
//          'isBorrowerNotified': true,
//          'uploadedDocuments': [{
//              'guid': 'string',
//              'type': 'PhotoId',
//              'fileName': 'string',
//              'description': 'string',
//              'loanApplicationTaskGuid': 'string',
//              'blobGuid': 'string',
//              'blobName': 'string',
//              'dateCreated': '2016-11-29T23:33:05.245Z',
//              'dateUpdated': '2016-11-29T23:33:05.245Z',
//              'dateRequested': '2016-11-29T23:33:05.245Z',
//              'dateReceived': '2016-11-29T23:33:05.245Z',
//              'isDeleted': true,
//              'status': 'Queued',
//              'disposition': 'NotReviewed',
//              'dispositionAgentGuid': 'string',
//              'dispositionAgentName': 'string',
//              'dispositionDate': '2016-11-29T23:33:05.245Z'
//            }],
//          'requestedBy': 'string',
//          'dateRequested': '2016-11-29T23:33:05.245Z',
//          'dateCompleted': '2016-11-29T23:33:05.245Z'
//        }, {
//          'guid': 'string',
//          'loanApplicationGuid': 'string',
//          'userGuid': 'string',
//          'type': 'UploadDocument',
//          'status': 'NotStarted',
//          'title': 'Upload Driver\'s License',
//          'requestMessage': 'Please upload ONE of the following: Driver\'s License, ' +
//          'U.S. Passport, State Issued ID, or Permanent Resident Alien Card.',
//          'requestedUploadedDocumentTypes': [
//            'PhotoId'
//          ],
//          'isRequired': true,
//          'isBorrowerNotified': true,
//          'uploadedDocuments': [{
//              'guid': 'string',
//              'type': 'PhotoId',
//              'fileName': 'string',
//              'description': 'string',
//              'loanApplicationTaskGuid': 'string',
//              'blobGuid': 'string',
//              'blobName': 'string',
//              'dateCreated': '2016-11-29T23:33:05.245Z',
//              'dateUpdated': '2016-11-29T23:33:05.245Z',
//              'dateRequested': '2016-11-29T23:33:05.245Z',
//              'dateReceived': '2016-11-29T23:33:05.245Z',
//              'isDeleted': true,
//              'status': 'Queued',
//              'disposition': 'NotReviewed',
//              'dispositionAgentGuid': 'string',
//              'dispositionAgentName': 'string',
//              'dispositionDate': '2016-11-29T23:33:05.245Z'
//            }],
//          'requestedBy': 'string',
//          'dateRequested': '2016-11-29T23:33:05.245Z',
//          'dateCompleted': '2016-11-29T23:33:05.245Z'
//        }, {
//          'guid': 'string',
//          'loanApplicationGuid': 'string',
//          'userGuid': 'string',
//          'type': 'VerifyBankAccount',
//          'status': 'NotStarted',
//          'title': 'Upload Bank Statement',
//          'requestMessage': 'Please upload most recent bank statement from linked account. ' +
//          'Include all pages.',
//          'requestedUploadedDocumentTypes': [
//            'BankStatement'
//          ],
//          'isRequired': true,
//          'isBorrowerNotified': true,
//          'uploadedDocuments': [{
//              'guid': 'string',
//              'type': 'PhotoId',
//              'fileName': 'string',
//              'description': 'string',
//              'loanApplicationTaskGuid': 'string',
//              'blobGuid': 'string',
//              'blobName': 'string',
//              'dateCreated': '2016-11-29T23:33:05.245Z',
//              'dateUpdated': '2016-11-29T23:33:05.245Z',
//              'dateRequested': '2016-11-29T23:33:05.245Z',
//              'dateReceived': '2016-11-29T23:33:05.245Z',
//              'isDeleted': true,
//              'status': 'Queued',
//              'disposition': 'NotReviewed',
//              'dispositionAgentGuid': 'string',
//              'dispositionAgentName': 'string',
//              'dispositionDate': '2016-11-29T23:33:05.245Z'
//            }],
//          'requestedBy': 'string',
//          'dateRequested': '2016-11-29T23:33:05.245Z',
//          'dateCompleted': '2016-11-29T23:33:05.245Z'
//        }, {
//          'guid': 'string',
//          'loanApplicationGuid': 'string',
//          'userGuid': 'string',
//          'type': 'VerifyEmail',
//          'status': 'NotStarted',
//          'title': 'Verify Email',
//          'requestMessage': 'Check your email inbox and click on the email verification link ' +
//          'from loanDepot. Can\'t find the email, click button to resend.',
//          'requestedUploadedDocumentTypes': [],
//          'isRequired': true,
//          'isBorrowerNotified': true,
//          'uploadedDocuments': [{
//              'guid': 'string',
//              'type': 'PhotoId',
//              'fileName': 'string',
//              'description': 'string',
//              'loanApplicationTaskGuid': 'string',
//              'blobGuid': 'string',
//              'blobName': 'string',
//              'dateCreated': '2016-11-29T23:33:05.245Z',
//              'dateUpdated': '2016-11-29T23:33:05.245Z',
//              'dateRequested': '2016-11-29T23:33:05.245Z',
//              'dateReceived': '2016-11-29T23:33:05.245Z',
//              'isDeleted': true,
//              'status': 'Queued',
//              'disposition': 'NotReviewed',
//              'dispositionAgentGuid': 'string',
//              'dispositionAgentName': 'string',
//              'dispositionDate': '2016-11-29T23:33:05.245Z'
//            }],
//          'requestedBy': 'string',
//          'dateRequested': '2016-11-29T23:33:05.245Z',
//          'dateCompleted': '2016-11-29T23:33:05.245Z'
//        }, {
//          'guid': 'string',
//          'loanApplicationGuid': 'string',
//          'userGuid': 'string',
//          'type': 'UploadDocument',
//          'status': 'NotStarted',
//          'title': 'Other Document (Optional)',
//          'requestMessage': 'Upload other documents that might be relevant to verify' +
//          'your identity or income.',
//          'requestedUploadedDocumentTypes': [
//            'PhotoId',
//            'PayStubs',
//            'BankStatement',
//            'W2',
//            'RentalAgreement',
//            'VoidedCheck',
//            'Form1099',
//            'DisabilityIncome',
//            'PensionOrRetirement',
//            'UtilityBill',
//            'TaxReturn',
//            'ProofOfIncome',
//            'PropertyTaxBill',
//            'SocialSecurityAwardLetter',
//            'DivorceDecree',
//            'Other',
//            'AlternateIncome',
//            'LeaveAndEarningsStatement',
//            'CurrentProofOfReceipt'
//          ],
//          'isRequired': true,
//          'isBorrowerNotified': true,
//          'uploadedDocuments': [{
//              'guid': 'string',
//              'type': 'PhotoId',
//              'fileName': 'string',
//              'description': 'string',
//              'loanApplicationTaskGuid': 'string',
//              'blobGuid': 'string',
//              'blobName': 'string',
//              'dateCreated': '2016-11-29T23:33:05.245Z',
//              'dateUpdated': '2016-11-29T23:33:05.245Z',
//              'dateRequested': '2016-11-29T23:33:05.245Z',
//              'dateReceived': '2016-11-29T23:33:05.245Z',
//              'isDeleted': true,
//              'status': 'Queued',
//              'disposition': 'NotReviewed',
//              'dispositionAgentGuid': 'string',
//              'dispositionAgentName': 'string',
//              'dispositionDate': '2016-11-29T23:33:05.245Z'
//            }],
//          'requestedBy': 'string',
//          'dateRequested': '2016-11-29T23:33:05.245Z',
//          'dateCompleted': '2016-11-29T23:33:05.245Z'
//        }, {
//          'guid': 'string',
//          'loanApplicationGuid': 'string',
//          'userGuid': 'string',
//          'type': 'SignLoanPacket',
//          'status': 'NotStarted',
//          'title': 'Sign Loan Packet',
//          'requestMessage':
//            'Congratulations! Your application is approved. ' +
//            'Click the Sign button to accept the loan agreement. ' +
//            'After you sign, we will call you to confirm your acceptance before funding the loan.',
//          'requestedUploadedDocumentTypes': [
//            'Other'
//          ],
//          'isRequired': true,
//          'isBorrowerNotified': true,
//          'uploadedDocuments': [{
//              'guid': 'string',
//              'type': 'Other',
//              'fileName': 'string',
//              'description': 'string',
//              'loanApplicationTaskGuid': 'string',
//              'blobGuid': 'string',
//              'blobName': 'string',
//              'dateCreated': '2016-11-29T23:33:05.245Z',
//              'dateUpdated': '2016-11-29T23:33:05.245Z',
//              'dateRequested': '2016-11-29T23:33:05.245Z',
//              'dateReceived': '2016-11-29T23:33:05.245Z',
//              'isDeleted': true,
//              'status': 'Queued',
//              'disposition': 'NotReviewed',
//              'dispositionAgentGuid': 'string',
//              'dispositionAgentName': 'string',
//              'dispositionDate': '2016-11-29T23:33:05.245Z'
//            }],
//          'requestedBy': 'string',
//          'dateRequested': '2016-11-29T23:33:05.245Z',
//          'dateCompleted': '2016-11-29T23:33:05.245Z'
//        }, {
//          'guid': 'string',
//          'loanApplicationGuid': 'string',
//          'userGuid': 'string',
//          'type': 'SubmitLoanApplication',
//          'status': 'NotStarted',
//          'title': 'Submit Loan Application',
//          'requestMessage': 'When you apply for a loan, we will request your credit report from one or more credit reporting agencies.',
//          'requestedUploadedDocumentTypes': [],
//          'isRequired': true,
//          'isBorrowerNotified': true,
//          'uploadedDocuments': [{
//              'guid': 'string',
//              'type': 'PhotoId',
//              'fileName': 'string',
//              'description': 'string',
//              'loanApplicationTaskGuid': 'string',
//              'blobGuid': 'string',
//              'blobName': 'string',
//              'dateCreated': '2016-11-29T23:33:05.245Z',
//              'dateUpdated': '2016-11-29T23:33:05.245Z',
//              'dateRequested': '2016-11-29T23:33:05.245Z',
//              'dateReceived': '2016-11-29T23:33:05.245Z',
//              'isDeleted': true,
//              'status': 'Queued',
//              'disposition': 'NotReviewed',
//              'dispositionAgentGuid': 'string',
//              'dispositionAgentName': 'string',
//              'dispositionDate': '2016-11-29T23:33:05.245Z'
//            }],
//          'requestedBy': 'string',
//          'dateRequested': '2016-11-29T23:33:05.245Z',
//          'dateCompleted': '2016-11-29T23:33:05.245Z'
//        }];
//      });
//  }
// }
